module.exports = __webpack_public_path__ + "fonts/Simply Rounded Bold.d30cb2ad.ttf";